import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.eventModifier.length === 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(_ctx.styles.container),
        onClick: _cache[0] || (_cache[0] = (e) => _ctx.$emit('click', e))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4))
    : (_ctx.eventModifier === 'stop')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle(_ctx.styles.container),
          onClick: _cache[1] || (_cache[1] = _withModifiers((e) => _ctx.$emit('click', e), ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 4))
      : _createCommentVNode("", true)
}